import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { LookupsState, lookupsFeature } from './lookups/lookups.reducer';
import { ScreenState, screenStateFeature } from './screen-state/screen-state.reducer';
import { persistScreenState } from './screen-state/screen-state.storage';

export interface AppState {
  screenState: ScreenState;
  lookups: LookupsState;
}

export const reducers: ActionReducerMap<AppState> = {
  screenState: screenStateFeature.reducer,
  lookups: lookupsFeature.reducer
};

export const metaReducers: MetaReducer<AppState>[] = [persistScreenState];
